// src/features/user/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  authToken: '',
  isAuthenticated: false,
  user: {},
  resetPasswordStatus: '',
  resetPasswordError: '',
  isResettingPassword: false,
  isResettingPasswordWithOTP: false,
  isLoading: false,
  error: null
};

const authSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserEmail: (state, action) => {
      state.email = action.payload;
    },
    setAuthToken: (state, action) => {
      state.authToken = action.payload;
      state.isAuthenticated = true;
    },
    setUserDetails: (state, action) => {
      state.user = action.payload;
    },
    logoutUser: () => initialState,
    
    // API request states
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    
    // Reset Password
    resetPasswordRequest: (state) => {
      state.isResettingPassword = true;
      state.resetPasswordStatus = '';
      state.resetPasswordError = '';
    },
    resetPasswordSuccess: (state, action) => {
      state.isResettingPassword = false;
      state.resetPasswordStatus = action.payload;
    },
    resetPasswordFailure: (state, action) => {
      state.isResettingPassword = false;
      state.resetPasswordError = action.payload;
    },
    
    // Forgot Password
    forgotPasswordRequest: (state) => {
      state.isResettingPasswordWithOTP = true;
      state.resetPasswordStatus = '';
      state.resetPasswordError = '';
    },
    forgotPasswordSuccess: (state, action) => {
      state.isResettingPasswordWithOTP = false;
      state.resetPasswordStatus = action.payload;
    },
    forgotPasswordFailure: (state, action) => {
      state.isResettingPasswordWithOTP = false;
      state.resetPasswordError = action.payload;
    },

    // Update User Profile
    updateUserProfileRequest: (state) => {
      state.isUpdatingProfile = true;
      state.updateProfileError = '';
    },
    updateUserProfileSuccess: (state, action) => {
      state.isUpdatingProfile = false;
      state.user = action.payload; // Update user details in state
    },
    updateUserProfileFailure: (state, action) => {
      state.isUpdatingProfile = false;
      state.updateProfileError = action.payload;
    },
  },
});

// Export actions
export const {
  setUserEmail,
  setAuthToken,
  setUserDetails,
  logoutUser,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetPasswordFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  updateUserProfileRequest,
  updateUserProfileSuccess,
  updateUserProfileFailure,
} = authSlice.actions;

// Export selectors
export const selectEmail = (state) => state.auth.email;
export const selectAuthToken = (state) => state.auth.authToken;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUserDetails = (state) => state.auth.user;
export const selectIsLoading = (state) => state.auth.isLoading;
export const selectError = (state) => state.auth.error;
export const selectResetPasswordStatus = (state) => state.auth.resetPasswordStatus;
export const selectResetPasswordError = (state) => state.auth.resetPasswordError;
export const selectIsResettingPassword = (state) => state.auth.isResettingPassword;
export const selectIsResettingPasswordWithOTP = (state) => state.auth.isResettingPasswordWithOTP;
export const selectIsUpdatingProfile = (state) => state.auth.isUpdatingProfile;
export const selectUpdateProfileError = (state) => state.auth.updateProfileError;

// Export reducer
export default authSlice.reducer;